import request from '@/utils/request';

export const complain = (data: any) =>
  request({
    url: 'Order/systemComplain',
    method: 'POST',
    data
  });

export const getOrderComplaintList = (params: any) =>
  request({
    url: 'OrderService/orderComplainList',
    method: 'get',
    params
  });
